import { render, staticRenderFns } from "./privacy.vue?vue&type=template&id=e546cfd6&scoped=true&"
var script = {}
import style0 from "./privacy.vue?vue&type=style&index=0&id=e546cfd6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e546cfd6",
  null
  
)

export default component.exports